/**
 * ========================================================================
 * 🔑 CENTRALIZED FACEBOOK CONFIGURATION - FRONTEND
 * ========================================================================
 * 
 * This file contains all Facebook-related configuration for the frontend.
 * 
 * IMPORTANT: The permissions list MUST match backend/config/api.js
 * 
 * This is the single source of truth for Facebook permissions in the frontend.
 * All components and services should import from this file.
 * 
 * ========================================================================
 */

/**
 * Facebook Page Permissions
 * These permissions are required for comment moderation functionality.
 * 
 * MUST match backend/config/api.js permissionsArray
 * 
 * NOTE: Messaging permissions commented out for Facebook app review
 * Only submitting comment moderation feature initially
 */
export const FACEBOOK_PAGE_PERMISSIONS = [
  "pages_show_list",          // List user's Facebook pages
  "pages_read_user_content",  // Read posts + user comments (READ ONLY)
  "pages_read_engagement",    // Read Page-authored content; required to manage comments on Page posts
  "pages_manage_engagement",  // Hide/delete/reply to comments
  "pages_manage_metadata",    // Subscribe to webhooks
  "pages_messaging",          // Send DMs to commenters (requires reconnect to take effect)
];

/**
 * Facebook User Permissions
 * These are basic user-level permissions needed for OAuth
 */
export const FACEBOOK_USER_PERMISSIONS = [
  "email", // Basic user email
  "public_profile", // Basic user profile
];

/**
 * All Facebook Permissions Combined
 * This includes both user-level and page-level permissions
 */
export const FACEBOOK_PERMISSIONS = [
  ...FACEBOOK_USER_PERMISSIONS,
  ...FACEBOOK_PAGE_PERMISSIONS,
];

/**
 * Facebook API Configuration
 */
export const facebookConfig = {
  clientId: process.env.REACT_APP_FACEBOOK_CLIENT_ID,
  clientSecret: process.env.REACT_APP_FACEBOOK_CLIENT_SECRET,
  permissions: FACEBOOK_PERMISSIONS,
  permissionsString: FACEBOOK_PERMISSIONS.join(" "),
  permissionsCommaString: FACEBOOK_PERMISSIONS.join(","),
};

export default facebookConfig;

